import {action} from "mobx";
import heatMapService from "../services/heatMapService";
import appStore from "./appStore";

class heatMapStore {
    @action getHeatMap = async params => {
        const resultOfRequest = await heatMapService.getHeatMap(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new heatMapStore();